import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Row, Col, Form, Button,  FormGroup, FormControl } from 'react-bootstrap';
import Swal from 'sweetalert2';
import '../../../../App.scss';


const M5_Ejercicio10 = ({ cerrarModal }) => {

    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [respuestas, setRespuestas] = useState({
        // Raíz: physis = naturaleza
        fisioterapia: '',
        
        // Raíz: polis, polys = muchos
        poligamia: '',
        
        poligono: '',
        
        // Raíz: tele = lejos, a distancia, a lo lejos
        television: '',
        telefono: '',
        telegrama: '',
        telepatia: '',
        
        // Raíz: theos, teos = dios
        teologia: '',
        teocracia: '',
        teofilo: '',
        ateo: '',

        // Raíz: sophia = saber, ciencia

        

        //Raíz syn = unión, inclusión, unión en uno solo.

        sintesis: '',
        simpatia: '',
        simbolico: '',
        sinfonia: '',
        simetrico: '',
        sintonia: '',
        sinoptico: '',
        sinergia: '',
        

        
        // Raíz: sarkos = carne, cuerpo
        
        sarcofago: '',
        sarcasmo: '',

        // Raíz: therapeu, therapautos = curar, cultivar, cuidar
        hidroterapia: '',
        psicoterapia: '',
        terapeuta: '',
        
        // Raíz: xenos = extranjero, ajeno
        xenofobia: '',
        xenofilia: '',

        // Raíz: zoon = animal, ser viviente
        zoologia: '',
        zoologico: '',
        protozoo: ''
        

    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setRespuestas(prevRespuestas => ({
            ...prevRespuestas,
            [name]: value
        }));
    };


    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        if (!Object.values(respuestas).every(value => value.trim() !== '')) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Todos los campos deben estar llenos antes de enviar la evaluación.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 10 - Ejercicio de Comprensión",
                nivel: "Basico",
                modulo: "5",
                createdAt: new Date(),
                tipo: "Texto libre",
                respuestas
            });
            Swal.fire({
                title: '¡Evaluación Enviada!',
                text: 'Resultados enviados con éxito.',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then((result) => {
                if (result.isConfirmed) {
                    cerrarModal();  // Cierra la modal al confirmar la alerta
                }
            });
        } catch (error) {
            console.error("Error al enviar las respuestas: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al enviar las respuestas.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Aceptar'
            });
        }
    };

    return (
        <div className="container mt-4">
            <h3>Nivel Básico</h3>
            <h3>Módulo 5 - Ejercicio 10</h3>
            <h5>Ejercicio de comprensión</h5>

            
            <p><strong>Incremente su vocabulario</strong></p>


            <Row>
                <Col md={6}>

                    <Form className='border p-3'>

                        <p><strong>Raiz: physis = naturaleza.</strong></p>
                        <p>Física: Ciencia que estudia los cuerpos de la naturaleza <br />
                            Fisonomía: Aspecto físico</p>

                            
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Fisioterapia</div>
                                <FormControl
                                    type="text"
                                    name="fisioterapia"
                                    value={respuestas.fisioterapia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                           <p>
                            Fisiología: Ciencia que estudia la vida.</p> 
                        

                        </Form>


                        <br />

                        <Form className='border p-3'>




                            <p><strong>Raíz: Polis, polys = muchos</strong></p>
                            
                            
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Poligamia</div>
                                <FormControl
                                    type="text"
                                    name="poligamia"
                                    value={respuestas.poligamia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <p>Poliglota: Que habla muchos idiomas</p>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Polígono</div>
                                <FormControl
                                    type="text"
                                    name="poligono"
                                    value={respuestas.poligono}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Form>
                        <br />

                        <Form className='border p-3'>

                            <p><strong>Raíz: tele = lejos, a distancia, a lo lejos</strong></p>
                            
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Televisión</div>
                                <FormControl
                                    type="text"
                                    name="television"
                                    value={respuestas.television}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Teléfono</div>
                                <FormControl
                                    type="text"
                                    name="telefono"
                                    value={respuestas.telefono}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Telegrama</div>
                                <FormControl
                                    type="text"
                                    name="telegrama"
                                    value={respuestas.telegrama}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Telepatía</div>
                                <FormControl
                                    type="text"
                                    name="telepatia"
                                    value={respuestas.telepatia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Form>
                        <br />


                        <Form className='border p-3'>

                            <p><strong>Raíz: theos, teos = dios</strong></p>
                            <p>Teodor: donde dios</p>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Teología</div>
                                <FormControl
                                    type="text"
                                    name="teologia"
                                    value={respuestas.teologia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Teocracia</div>
                                <FormControl
                                    type="text"
                                    name="teocracia"
                                    value={respuestas.teocracia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Teofilo</div>
                                <FormControl
                                    type="text"
                                    name="teofilo"
                                    value={respuestas.teofilo}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Ateo</div>
                                <FormControl
                                    type="text"
                                    name="ateo"
                                    value={respuestas.ateo}
                                    onChange={handleChange}
                                />
                            </FormGroup>

                        </Form>
                        <br />

                        <Form className='border p-3'>
                            <p><strong>Raíz: sophia = saber, ciencia</strong></p>
                            <p>Filósofo: Amigo del estudio, de la ciencia. Filos es amigo.
                            </p>
                    </Form>    
                </Col>
                <Col md={6}>
                    <div>
                        <Form className='border p-3'>
                            <p><strong>Raíz:  syn = unión, inclusión, unión en uno solo.</strong></p>
                            
                            <FormGroup className="mb-3 ">
                                <div className="text-muted small mb-1">Síntesis</div>
                                <FormControl
                                    type="text"
                                    name="sintesis"
                                    value={respuestas.sintesis}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Simpatía</div>
                                <FormControl
                                    type="text"
                                    name="simpatia"
                                    value={respuestas.simpatia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Simbólico</div>
                                <FormControl
                                    type="text"
                                    name="simbolico"
                                    value={respuestas.simbolico}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Sinfonía</div>
                                <FormControl
                                    type="text"
                                    name="sinfonia"
                                    value={respuestas.sinfonia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Simétrico</div>
                                <FormControl
                                    type="text"
                                    name="simetrico"
                                    value={respuestas.simetrico}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Sintonia</div>
                                <FormControl
                                    type="text"
                                    name="sintonia"
                                    value={respuestas.sintonia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Sinóptico</div>
                                <FormControl
                                    type="text"
                                    name="sinoptico"
                                    value={respuestas.sinoptico}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Sinergia</div>
                                <FormControl
                                    type="text"
                                    name="sinergia"
                                    value={respuestas.sinergia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <p>Sintaxis: Unido con un orden</p>

                        </Form>
                        <br />
                        <Form className='border p-3'>

                            <p><strong>Raíz: sarkos = carne, cuerpo</strong></p>
                            <p>Sarcoma: Tumor de tejido.
                            </p>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Sarcófago</div>
                                <FormControl
                                    type="text"
                                    name="sarcofago"
                                    value={respuestas.sarcofago}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Sarcasmo</div>
                                <FormControl
                                    type="text"
                                    name="sarcasmo"
                                    value={respuestas.sarcasmo}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Form>
                        <br />
                        <Form className='border p-3'>


                            <p><strong>Raíz: therapeu, therapautos = curar, cultivar, cuidar.</strong></p>
                            
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Hidroterapia</div>
                                <FormControl
                                    type="text"
                                    name="hidroterapia"
                                    value={respuestas.hidroterapia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Psicoterapia</div>
                                <FormControl
                                    type="text"
                                    name="psicoterapia"
                                    value={respuestas.psicoterapia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Terapeuta</div>
                                <FormControl
                                    type="text"
                                    name="terapeuta"
                                    value={respuestas.terapeuta}
                                    onChange={handleChange}
                                />
                            </FormGroup>

                        </Form>
                        <br />
                        <Form className='border p-3'>



                            <p><strong>Raíz: xenos = extranjero, ajeno</strong></p>

                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Xenofobia</div>
                                <FormControl
                                    type="text"
                                    name="xenofobia"
                                    value={respuestas.xenofobia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Xenofilia</div>
                                <FormControl
                                    type="text"
                                    name="xenofilia"
                                    value={respuestas.xenofilia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Form>
                        <br />
                        <Form className='border p-3'>
                            <p><strong>Raíz: zoon = animal, ser viviente</strong></p>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Zoología</div>
                                <FormControl
                                    type="text"
                                    name="zoologia"
                                    value={respuestas.zoologia}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Zoológico</div>
                                <FormControl
                                    type="text"
                                    name="zoologico"
                                    value={respuestas.zoologico}
                                    onChange={handleChange}
                                />
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Protozoo</div>
                                <FormControl
                                    type="text"
                                    name="protozoo"
                                    value={respuestas.protozoo}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            
                            </Form>





                    </div>
                </Col>
                <Button onClick={enviarResultados} variant="primary">Enviar Resultados</Button>
            </Row>
        </div>
    );
};




export default M5_Ejercicio10;
